var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-switch',{staticClass:"has-margin-top-25",class:{ 'has-cursor-wait': _vm.processing },attrs:{"value":_vm.task.needsAttention,"disabled":_vm.processing,"type":"is-success"},on:{"input":_vm.markAsNeedsAttenton}},[_vm._v(" "+_vm._s(_vm.task.needsAttention ? "Required" : "Not required")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }